import store from 'redux/store';
import { status } from 'constants/general';
import hideElements from 'configs/hideElements';
import { setContext, fetchStaticData } from 'modules/common/actions';

const initApp = context => {
  store.dispatch(setContext(context));

  if (
    store?.getState()?.common?.staticData.status === status.SHOULD_CALL_API &&
    hideElements.contextsThatDontRequireStaticData.includes(context) === false
  )
    store.dispatch(fetchStaticData());
};

export default initApp;
